import { render, staticRenderFns } from "./ProductTabsIndexDt.vue?vue&type=template&id=332928d1&scoped=true&"
import script from "./ProductTabsIndexDt.vue?vue&type=script&lang=js&"
export * from "./ProductTabsIndexDt.vue?vue&type=script&lang=js&"
import style0 from "./ProductTabsIndexDt.vue?vue&type=style&index=0&id=332928d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332928d1",
  null
  
)

export default component.exports